import React from "react";

function Policy() {
  return (
    <section className="privacy-section">
      <div className="privacy-container">
        <div className="privacy-content-wrapper">
          <h1 className="privacy-content-title">
            Eﬀective Date: 21 November 2025
          </h1>
          <p className="privacy-content-description">
            This Privacy Policy explains how <b>Updapt CSR Private Limited</b>
            (“Updapt”, “we”, “our”, or “us”) collects, uses, discloses and
            protects personal information when individuals visit or interact
            with our website{" "}
            <a href=" https://updapt.com/" className="privacy-content-link">
              {" "}
              www.updapt.com
            </a>{" "}
            (“Website”). By using our Website, attending our events or webinars,
            communicating with us, or visiting our offices, you acknowledge and
            agree to this Privacy Policy.
          </p>
          <p className="privacy-content-description">
            For the purposes of personal information collected through this
            Website, Updapt CSR Private Limited acts as the data controller. For
            Customer Data processed within the Updapt SaaS platform, Updapt acts
            as a data processor on behalf of its customers, in accordance with
            the applicable Data Processing Agreement (DPA).
          </p>
          <p className="privacy-content-description">
            This Privacy Policy does not apply to the data processed within the
            Updapt SaaS platform. For our SaaS customers, data processing is
            governed by a separate <b>Data Processing Agreement (DPA)</b>{" "}
            executed with each customer.
          </p>
          <h1 className="privacy-content-title">
            1. Personal Information We Collect
          </h1>
          <p className="privacy-content-description">
            When you interact with our Website, we may collect personal
            information that you choose to provide to us directly such as when
            you submit a contact form, request a demo, apply for a job,
            subscribe to updates, or otherwise communicate with us. This may
            include your name, email address, phone number, company information,
            job application details, and any other information you voluntarily
            provide.
          </p>
          <p className="privacy-content-description">
            If you register for, attend, or participate in our events or
            webinars (virtual or in-person), we may collect additional
            information such as your title, country/state, and where applicable
            billing information for paid registrations.
          </p>
          <p className="privacy-content-description">
            In addition, certain information is collected automatically through
            your browser or device when you access our Website. This may include
            your IP address, browser type, device details, pages visited, time
            spent on the Website, and information collected through cookies and
            similar technologies. Cookies help us understand how our Website is
            used, improve its performance, and enhance your browsing experience.
            You can modify your browser settings to refuse or disable cookies;
            however, doing so may affect certain Website functionalities.
          </p>
          <p className="privacy-content-description">
            We may receive information about you from publicly available
            sources, social media platforms, purchased marketing data, and
            third-party analytics or advertising partners to better understand
            user preferences and improve our marketing efforts.
          </p>
          <h1 className="privacy-content-title">
            2. How We Use Your Information
          </h1>
          <p className="privacy-content-description">
            We use the personal information collected through our Website for
            the purposes for which it was provided and for other legitimate
            business purposes. This includes responding to enquiries, providing
            information about our services, arranging product demonstrations,
            processing job applications, managing event or newsletter
            subscriptions, and improving the overall performance and usability
            of our Website.
          </p>
          <p className="privacy-content-description">
            Additional purposes may include user-experience analysis, survey
            administration, event or webinar management, authentication for
            secure access to any Updapt community or resource portals, fraud
            detection, and marketing analytics.
          </p>
          <p className="privacy-content-description">
            We may analyze Website usage patterns to understand visitor
            behaviour, enhance content, troubleshoot issues, and maintain the
            security and integrity of our systems. Where permitted, we may also
            use your information to send updates or marketing communications
            about our services. You may opt out of such communications at any
            time.
          </p>
          <p className="privacy-content-description">
            We will not use personal information for purposes that are
            incompatible with those described in this Privacy Policy without
            your consent or unless permitted by law.
          </p>
          <h1 className="privacy-content-title">
            3. Sharing of Personal Information
          </h1>
          <p className="privacy-content-description">
            Updapt does <b>not</b> sell or rent personal information.
          </p>
          <p className="privacy-content-description">
            We may share personal information with trusted third-party service
            providers who assist us in operating, hosting, or improving our
            Website, or in managing communications and analytics. These service
            providers process personal information solely under our documented
            instructions and are contractually bound to maintain strict
            confidentiality and implement appropriate technical and
            organizational security measures consistent with applicable data
            protection laws..
          </p>
          <p className="privacy-content-description">
            We may also share personal information with selected commercial or
            collaboration partners for lawful joint marketing, co-hosted events,
            or product-related initiatives, subject to your applicable opt-out
            rights.
          </p>
          <p className="privacy-content-description">
            We may disclose personal information at your direction or with your
            explicit consent.
          </p>
          <p className="privacy-content-description">
            We may also disclose personal information if required by law, legal
            process, regulatory request, or to protect our rights, security, or
            the rights and safety of others. If Updapt undergoes a corporate
            restructuring, merger, acquisition, or similar transaction, personal
            information may be transferred as part of that transaction under
            appropriate confidentiality protections.
          </p>
          <h1 className="privacy-content-title">4. International Transfers</h1>
          <p className="privacy-content-description">
            Updapt is headquartered in India. Personal information collected
            through our Website may be processed in India or in other countries
            where our service providers are located. When personal information
            is transferred across borders, we ensure that adequate safeguards
            are in place as required by applicable laws, including India’s
            Digital Personal Data Protection Act, 2023 (“DPDPA”), the EU General
            Data Protection Regulation (“GDPR”), and other relevant regulations.
          </p>
          <p className="privacy-content-description">
            For individuals located in the EU, UK, or EEA, our legal bases for
            processing personal information may include consent, performance of
            a contract, compliance with legal obligations, and our legitimate
            interests. You may have the right to object to processing based on
            legitimate interests.
          </p>
          <p className="privacy-content-description">
            When transferring personal information outside your jurisdiction, we
            may rely on legally approved mechanisms such as Standard Contractual
            Clauses, adequacy decisions, or other lawful transfer mechanisms
            recognized under GDPR or applicable privacy laws.
          </p>
          <p className="privacy-content-description">
            Where applicable, we take steps to ensure that onward transfers by
            our service providers maintain equivalent levels of protection.
          </p>
          <h1 className="privacy-content-title">5. Data Retention</h1>
          <p className="privacy-content-description">
            We retain personal information only for as long as necessary to
            fulfil the purposes for which it was collected, to comply with legal
            or regulatory obligations, to resolve disputes, or to enforce our
            agreements. Information submitted through our Website may be stored
            for a reasonable period to enable follow-up communication unless you
            request its deletion.
          </p>
          <p className="privacy-content-description">
            We may retain certain information for longer periods where required
            for compliance, audit, tax, fraud prevention, dispute resolution, or
            legal reporting obligations.
          </p>
          <h1 className="privacy-content-title">6. Your Rights</h1>
          <p className="privacy-content-description">
            Depending on the laws applicable to your jurisdiction, you may have
            the right to request access to the personal information we hold
            about you, the right to request correction or deletion, the right to
            withdraw consent, the right to object to certain types of
            processing, and the right to lodge a complaint with a data
            protection authority. We will respond to all valid requests within
            the timelines prescribed by applicable laws.
          </p>
          <p className="privacy-content-description">
            Additional rights may be available under certain privacy regimes,
            including the right to restrict processing, the right to data
            portability, and the right to opt out of the “sharing” of personal
            information for targeted advertising as defined under applicable
            U.S. state privacy laws.{" "}
          </p>
          <p className="privacy-content-description">
            To submit a rights request under the DPDPA, GDPR, or other
            applicable laws, you may contact our Grievance Officer or Data
            Protection Officer using the contact details provided below. We may
            take reasonable steps to verify your identity before responding to
            your request.In accordance with the Digital Personal Data Protection
            Act, 2023, we will acknowledge grievances within 7 working days and
            aim to resolve them within 30 days from the date of receipt.
          </p>
          <p className="privacy-content-description">
            To exercise these rights or raise any privacy-related concerns, you
            may contact us at
            <a
              href="mailto:legal@updaptcsr.com"
              className="privacy-content-link"
            >
              {" "}
              legal@updaptcsr.com
            </a>
            .
          </p>
          <p className="privacy-content-description">
            If you unsubscribe from marketing communications, we will retain
            minimal information necessary to ensure compliance with your opt-out
            preferences.
          </p>
          <h1 className="privacy-content-title">7. Security</h1>
          <p className="privacy-content-description">
            We implement reasonable administrative, technical, and
            organizational measures to protect personal information against
            unauthorized access, loss, misuse, or alteration. While we strive to
            safeguard all information, no method of transmission over the
            internet or electronic storage is completely secure. We encourage
            users to exercise caution when sharing personal information online.
          </p>
          <p className="privacy-content-description">
            Where access to any restricted or authenticated sections of our
            Website is provided, users are responsible for maintaining the
            confidentiality of their login credentials and notifying us promptly
            if unauthorized access is suspected.
          </p>
          <p className="privacy-content-description">
            Please be aware that unsolicited or suspicious messages purporting
            to be from Updapt may constitute phishing attempts. If you receive
            such a communication, please notify us immediately.
          </p>
          <h1 className="privacy-content-title">
            8. Links to External Websites
          </h1>
          <p className="privacy-content-description">
            Our Website may contain links to third-party websites. We are not
            responsible for the privacy practices, content, or security of such
            external sites. We encourage you to review the privacy policies of
            any third-party sites you visit.
          </p>
          <p className="privacy-content-description">
            These third-party websites may use cookies, pixels, or tracking
            technologies that are not controlled by Updapt. Accessing such sites
            is at your own risk, and this Privacy Policy does not apply to any
            information collected by third-party websites or services.
          </p>
          <h1 className="privacy-content-title">9. Children’s Privacy</h1>
          <p className="privacy-content-description">
            Our Website is not intended for use by children under the age of 16.
            We do not knowingly collect personal information from children. If
            you believe a child has provided information through our Website,
            please contact us so that we may remove it.
          </p>
          <p className="privacy-content-description">
            If we become aware that personal information from a child under the
            age of 16 has been collected inadvertently, we will take reasonable
            steps to delete such information in compliance with applicable law.
          </p>
          <h1 className="privacy-content-title">10. SaaS Platform Users</h1>
          <p className="privacy-content-description">
            Please note that this Privacy Policy applies solely to our Website.
            <br />
            If you are an Updapt SaaS platform customer or user, the collection
            and processing of data within the platform is governed by the{" "}
            <b>Data Processing Addendum (DPA)</b> executed between Updapt CSR
            Private Limited and your organization.
          </p>
          <p className="privacy-content-description">
            For clarity, Updapt acts as the data processor for Customer Data
            processed within the SaaS platform and will process such data only
            on documented instructions from the customer, consistent with the
            terms of the DPA.{" "}
          </p>
          <p className="privacy-content-description">
            Access to the SaaS platform may require user authentication. Users
            are responsible for keeping their credentials confidential and
            notifying their organization or Updapt immediately in case of
            suspected compromise.{" "}
          </p>
          <h1 className="privacy-content-title">11. Contact Information</h1>
          <p className="privacy-content-description">
            If you have any questions about this Privacy Policy or wish to
            exercise your data rights, you may contact our Data Protection
            Officer / Grievance Officer at:
            <br />
            <b>Updapt CSR Private Limited</b>
            <br />
            M08, Gopalan Gardenia, Veerasandra Main Road,
            <br />
            Electronics City, Bangalore – 560100, India
            <br />
            Email:{" "}
            <a
              href="mailto:infosec@updaptcsr.com"
              className="privacy-content-link"
            >
              infosec@updaptcsr.com
            </a>
          </p>
          <p className="privacy-content-description">
            You may also contact us at legal@updaptcsr.com for privacy-related
            concerns or to submit data subject rights requests under applicable
            laws.{" "}
          </p>
          <p className="privacy-content-description">
            Individuals may have the right to lodge complaints with their local
            data protection authority if they believe their privacy rights have
            been violated. Upon request, we can provide contact details for
            relevant supervisory authorities.We will acknowledge grievances
            within 7 working days and endeavour to resolve them within 30 days,
            in accordance with the Digital Personal Data Protection Act, 2023.
          </p>
          <h1 className="privacy-content-title">
            12. Changes to This Privacy Policy
          </h1>
          <p className="privacy-content-description">
            We may update this Privacy Policy from time to time to reflect
            legal, technical, or business developments. When we update the
            Policy, we will revise the “Effective Date” at the top of this page.
            We encourage you to review this Policy periodically to stay informed
            about how we protect your information.
          </p>
          <p className="privacy-content-description">
            For material updates, we may provide supplementary notice, such as
            posting a prominent update banner on our Website homepage or sending
            direct notification where legally required.
          </p>
          <p className="privacy-content-description">
            Your continued use of the Website after changes to this Privacy
            Policy indicates your acceptance of the updated terms.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Policy;
